import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { IMegaMenuItem, IMegaMenuListResponse } from 'src/interfaces/mega-menu'
import { getListMegaMenu, updateMegaMenu } from '../actions/mega-menu'

interface MegaMenuState {
  megaMenus: IMegaMenuItem[]
  loading: boolean
  error: string | null
  updateLoading: boolean
  updateError: string | null
}

const initialState: MegaMenuState = {
  megaMenus: [],
  loading: false,
  error: null,
  updateLoading: false,
  updateError: null,
}

const megaMenuSlice = createSlice({
  name: 'megaMenu',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null
      state.updateError = null
    },
    resetState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      // Get list mega menu
      .addCase(getListMegaMenu.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(
        getListMegaMenu.fulfilled,
        (state, action: PayloadAction<IMegaMenuListResponse>) => {
          state.loading = false
          state.megaMenus = action.payload.data.items
        }
      )
      .addCase(getListMegaMenu.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload as string
      })

      // Update mega menu
      .addCase(updateMegaMenu.pending, (state) => {
        state.updateLoading = true
        state.updateError = null
      })
      .addCase(updateMegaMenu.fulfilled, (state, action) => {
        state.updateLoading = false
        const { id, data } = action.payload
        const index = state.megaMenus.findIndex(
          (item: IMegaMenuItem) => item.id === id
        )
        if (index !== -1) {
          state.megaMenus[index] = { ...state.megaMenus[index], ...data }
        }
      })
      .addCase(updateMegaMenu.rejected, (state, action) => {
        state.updateLoading = false
        state.updateError = action.payload as string
      })
  },
})

export const { clearError, resetState } = megaMenuSlice.actions
export default megaMenuSlice.reducer
